import React from 'react';
import RolesDropdown from '@/roles/containers/RolesDropdown';
import { states } from '@/constants/lifecycle';
import Filter from '@/components/Filter';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const SubscribersFilters = ({
  category,
  className,
  code,
  event,
  fluid,
}) => {
  const {
    allowRoleLink, filterTerm, readStatus, roleName,
  } = Selectors.useSubscribersFilters({ category, code, event });
  const fetchData = Events.useFetchSubscribers(category, { code });
  const updateFilterTerm = Events.useUpdateSubscribersFilter(category, { code });
  const updateFilterRole = Events.useUpdateSubscribersRoleFilter(category, { code });

  const filterComponent = (
    <Filter
      className={fluid ? 'aridhia-list-filter' : undefined}
      error={readStatus === states.ERROR}
      filterTerm={filterTerm}
      fluid={fluid}
      onFilter={() => fetchData({ event, page: 1 })}
      updateFilter={({ value }) => updateFilterTerm({ event, value })}
    />
  );
  const dropDownComponent = (
    <RolesDropdown
      byName
      category="users"
      className={fluid ? 'mt-5' : 'mr-10'}
      clearable
      disabled={readStatus === states.PENDING}
      fluid={fluid}
      onChange={(e, { value }) => updateFilterRole({ event, role: value })}
      placeholder="roles.filter.placeholder"
      value={roleName}
    />
  );
  const components = { first: allowRoleLink ? dropDownComponent : null, second: filterComponent };
  if (allowRoleLink && fluid) {
    components.first = filterComponent;
    components.second = dropDownComponent;
  }

  return (
    <div className={`aridhia-subscribers-filters ${className}`}>
      {components.first && (<>{components.first}</>)}
      {components.second && (<>{components.second}</>)}
    </div>
  );
};

export default SubscribersFilters;
